import type { ComponentState, DailyUptime, Incident } from '../lib/types';
import { StatusPill } from './StatusPill';
import { UptimeBars } from './UptimeBars';

interface Props {
  component: ComponentState;
  history: DailyUptime[] | undefined;
  incidents: Incident[];
}

function formatLatency(ms: number | null): string | null {
  if (ms === null) return null;
  if (ms < 1000) return `${ms} ms`;
  return `${(ms / 1000).toFixed(2)} s`;
}

export function ComponentRow({ component, history, incidents }: Readonly<Props>) {
  const latency = formatLatency(component.latencyMs);

  return (
    <div className="border-b border-[var(--color-border-subtle)] py-5 last:border-b-0">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="font-display text-base font-medium text-[var(--color-fg)]">
            {component.name}
          </div>
          {component.description && (
            <div className="mt-0.5 text-sm text-[var(--color-fg-muted)]">
              {component.description}
            </div>
          )}
        </div>
        <div className="flex flex-col items-end gap-1 text-right">
          <StatusPill status={component.status} />
          {latency && (
            <span
              className="font-mono text-xs text-[var(--color-fg-subtle)]"
              title="p95 response time, last 5 minutes"
            >
              {latency}
            </span>
          )}
        </div>
      </div>
      {history && history.length > 0 && (
        <UptimeBars
          days={history}
          componentName={component.name}
          componentId={component.id}
          incidents={incidents}
        />
      )}
    </div>
  );
}
